<!--
 * @Author: wh
 * @Date: 2020-07-01 17:05:02
 * @LastEditTime: 2022-10-20 17:19:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\orderSituation\transOrderlist.vue
-->
<template>
    <div class="commonTableStyles transOrderlist">
        <van-nav-bar
            title="发货明细"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <template>
                <div class="warpper">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <template v-for="(item, index) in orderList">
                                <li :key="`orderList_${index}`">
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span class="state transStatus transStatus9 corner-marker" v-if="item.status===9">运输中</span>
                                            <span class="state transStatus transStatus2 corner-marker" v-else-if="item.status===2">作废</span>
                                            <span class="state transStatus transStatus3 corner-marker" v-else-if="item.status===3">完成</span>
                                            <span class="state transStatus transStatus0 corner-marker" v-else>未运输</span>
                                            <span class="headerName">运输单号:{{ item.pcb_number }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <span class="info">施工部位：{{ item.place_detail }}</span>
                                            </p>
                                            <p>
                                                <span class="info">施工单位：{{ item.sgdw_name }}</span>
                                            </p>
                                            <p>
                                                <van-row>
                                                    <van-col span="11">
                                                        <span class="info">发货方量：{{ item.volume }}m³</span>
                                                    </van-col>
                                                    <van-col span="13">
                                                        <span class="info">驾驶员：{{ item.sjxm }}</span>
                                                    </van-col>
                                                </van-row>
                                            </p>
                                            <p>
                                                <span class="info">车号：{{ item.shch }}</span>
                                            </p>
                                            <p>
                                                <span class="info">手机号：{{ item.sjsjh }}</span>
                                            </p>
                                            <p>
                                                <span class="info">供应场站：{{ item.station_name }}</span>
                                            </p>
                                            <p>
                                                <span class="info">生产机组：{{ item.line_name }}</span>
                                            </p>
                                            <p>
                                                <span class="info">发货时间：{{ item.deliver_time }}</span>
                                            </p>
                                            <p>
                                                <span class="info">工程名称：{{ item.project_name }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </div>
            </template>
        </van-pull-refresh>
        <!-- 加载层 -->
        <van-overlay :show="showOverlay">
            <van-loading type="spinner"></van-loading>
        </van-overlay>
    </div>
</template>
<script>
export default {
    beforeRouteLeave(to, from, next) {
        if (to.path === '/orderSituationList') {
            this.$store.commit('noKeepAlive', 'trans-orderlist');
        }
        next();
    },
    name: 'trans-orderlist',
    components: {},
    data() {
        return {
            orderList: [],
            loading: false,
            finished: false,
            page: {
                pageindex: 0,
                pagesize: 3,
            },
            total: true,
            cvid: '',
            // 下拉刷新
            isLoading: false,
            // 订单编号
            order_number: '',
            // 加载层
            showOverlay: false,
        };
    },
    activated() {
        // this.page.pageindex = 0;
        // this.orderList = [];
        // this.finished = false;
        // this.showOverlay = true;
        // this.order_number = this.$route.params.order_number;
        // this.getTransList();
    },
    created() {
    },
    mounted() {
        this.order_number = this.$route.params.order_number;
    },
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 下拉刷新
        onRefresh() {
            this.page.pageindex = 0;
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        // 根据关键词搜索
        handleSearch() {
            this.page.pageindex = 1;
            this.orderList = [];
            this.finished = false;
            this.getTransList();
        },
        // 分页拉取零售业务台账
        onLoad() {
            if (this.isLoading) {
                this.orderList = [];
                this.isLoading = false;
            }
            this.page.pageindex += 1;
            this.getTransList();
        },
        getTransList() {
            const queryStr = '?order_number=' + this.order_number + '&pageindex=' + this.page.pageindex + '&pagesize=' + this.page.pagesize;
            this.$axios
                .get('/interfaceApi/production/producttask/get_pcb_progress' + queryStr)
                .then(res => {
                    if (res) {
                        this.loading = false;
                        this.isLoading = false;
                        if (res.total) {
                            this.total = true;
                            this.orderList = this.orderList.concat(res.rows);
                            if (this.orderList.length >= res.total) {
                                this.finished = true;
                            }
                        } else {
                            this.total = false;
                            this.finished = true;
                        }
                    }
                    this.showOverlay = false;
                }).catch(error => {
                    this.showOverlay = false;
                    this.$toast(error.ErrorCode.Message);
                });
        },
    },

};
</script>

<style lang="stylus">
.transOrderlist
    height 100%
    background #F0F0F0
    .van-pull-refresh
        height 100%
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        .van-pull-refresh__track
            height 100%
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    .van-overlay
        .van-loading
            position absolute
            z-index 100
            top 50%
            left 50%
    .warpper
        height 100%
        background #F0F0F0
        overflow-y auto
        overflow-x hidden
        position relative
        .list
            li
                .transStatus
                    &.transStatus0
                        background-color #FF6600
                    &.transStatus9
                        background-color #0189FC
                    &.transStatus2
                        background-color #E60000
                    &.transStatus3
                        background-color #00A84B
</style>
<style>
    .retailAccountList .van-list__error-text, .van-list__finished-text, .van-list__loading{
        position: relative;
        height: 50rpx;
    }
    .retailAccountList .van-loading__spinner{
        position: relative!important;
        top: 0!important;
        left: 0!important;
        display: inline-block;
        width: 30px;
        max-width: 100%;
        height: 30px;
    }

</style>
